import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid py-5" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "card shadow-lg border-0" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "alert alert-info mb-4" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "badge bg-warning text-dark" }
const _hoisted_10 = { class: "card bg-light mb-4" }
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "row mb-3" }
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "fw-bold mb-0" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "fw-bold mb-0" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "fw-bold mb-0" }
const _hoisted_20 = { class: "col-6" }
const _hoisted_21 = { class: "mb-0" }
const _hoisted_22 = { class: "badge bg-warning text-dark" }
const _hoisted_23 = { class: "border-top pt-3 mt-3" }
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_25 = { class: "mb-0 text-primary fw-bold" }
const _hoisted_26 = { class: "d-grid gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("div", {
            class: "card-header text-center py-4",
            style: {"background":"linear-gradient(135deg, #28a745 0%, #20c997 100%)"}
          }, [
            _createElementVNode("i", { class: "fa fa-check-circle fa-4x text-white mb-3" }),
            _createElementVNode("h2", { class: "text-white fw-bold mb-0" }, "Dossier soumis avec succès !")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-file-text me-2" }, null, -1)),
                _cache[3] || (_cache[3] = _createTextVNode(" Référence BESC : ", -1)),
                _createElementVNode("strong", null, _toDisplayString(_ctx.besc?.refbesc), 1)
              ]),
              _createElementVNode("p", _hoisted_8, [
                _cache[4] || (_cache[4] = _createTextVNode(" Statut actuel : ", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.besc?.currentStatus?.label || 'Soumis - En attente de paiement'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "mb-3" }, [
                  _createElementVNode("i", { class: "fa fa-file-invoice-dollar me-2" }),
                  _createTextVNode(" Facture générée ")
                ], -1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-muted" }, "Référence facture", -1)),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.facture?.referenceFacture), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted" }, "Date d'émission", -1)),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.formatDate(_ctx.facture?.issueDate)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted" }, "Date d'échéance", -1)),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.formatDate(_ctx.facture?.dueDate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _cache[8] || (_cache[8] = _createElementVNode("small", { class: "text-muted" }, "Statut", -1)),
                    _createElementVNode("p", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.facture?.status), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "mb-0" }, "Montant à payer :", -1)),
                    _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.formatMoney(_ctx.facture?.montantTotal)) + " " + _toDisplayString(_ctx.facture?.currencyCode), 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-lg",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.proceedToPayment && _ctx.proceedToPayment(...args)))
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "fa fa-credit-card me-2" }, null, -1),
                _createTextVNode(" Procéder au paiement ", -1)
              ]))]),
              _createElementVNode("button", {
                class: "btn btn-outline-secondary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadInvoice && _ctx.downloadInvoice(...args)))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "fa fa-download me-2" }, null, -1),
                _createTextVNode(" Télécharger la facture ", -1)
              ]))]),
              _createVNode(_component_router_link, {
                to: { name: 'ListeBesc' },
                class: "btn btn-outline-primary"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "fa fa-list me-2" }, null, -1),
                  _createTextVNode(" Retour à la liste des BESC ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}